import FeedbackForm from '@/components/organism/FeedbackForm/FeedbackForm';

import { Container, ContentWrapper } from './Style';

const FeedbackPage = () => (
  <div className="container padding-y-25">
    <Container>
      <ContentWrapper>
        <FeedbackForm />
      </ContentWrapper>
    </Container>
  </div>
);

export default FeedbackPage;
